<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"><span class="text_">“A tale of profound, irrevocable changes in the middle of America in the 1960s, as a sheltered, upper-middle-class teenager becomes transformed, not only in his own physical and spiritual self, but also in his awareness of class and race and forces of discrimination he’d never had a clue of before. The narrative is powerful in its solid simplicity and dramatic, quietly vivid events. Although the time is past, the novel is very much of the present.”</span></p>
<p class="block_1"> </p>
<p class="block_2"><span class="text_">—Ellen Cooney, author of </span><span class="text_1">One Night Two Souls Went Walking </span></p>
<p class="block_1"> </p>
<p class="block_2"><span class="text_2">“</span><span class="text_">This is a very lovely, clear-eyed book about a young man’s dawning awareness of extraordinary men and women, as well as the hard realities, in a Midwestern town where he’s grown up. A generous and moving evocation of people living in a world that’s undergoing change, and the ways, some deeply compassionate, others coldly cruel, with which they move into the unknown.”</span></p>
<p class="block_1"> </p>
<p class="block_2"><span class="text_">—Douglas Penick, author of </span><span class="text_1">Journey of the North Star</span></p>
<p class="block_1"> </p>
<p class="block_2"><span class="text_">“The poignant tale of a teenager becoming a man over one summer in the 1960s as he learns lessons of love and evil in a small Midwestern town. The writing is lean and powerful.”</span></p>
<p class="block_1"> </p>
<p class="block_3"><span class="text_">—Don Trowden, author of </span><span class="text_1">Normal Family</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?5f2b0d1d